<!-- eslint-disable max-len -->
<template>
  <div class="relative">
    <div
      :class="[isInSettingTab ? 'mb-2' : 'info-row']"
    >
      <div
        :class="[isInSettingTab ? 'w-full mb-2' : 'info-col w-full md:w-1/2 md:pr-4']"
      >
        <div
          v-if="!isInSettingTab"
          class="mb-4 form-group"
        >
          <h5 class="font-bold">
            Name:
          </h5>
          <aha-input
            class="mt-2"
            v-model="name"
            :maxLength="100"
          ></aha-input>
        </div>
        <div class="form-group">
          <h5 class="font-bold">
            Description:
          </h5>
          <div class="text-area">
            <textarea
              placeholder="Enter your description..."
              :class="[isInSettingTab ? 'form-control text-area-expand' : 'form-control']"
              v-model="description"
              @blur="outFocusDes"
              @focus="focusDes"
              maxlength="200"
            />
            <div class="count-text" v-if="isFocusDescription">
              {{ 200 - description.length }}
            </div>
          </div>
        </div>
      </div>
      <div
        :class="[isInSettingTab ? 'w-full mt-5' : 'info-col w-full mt-2 md:w-1/2 md:mt-0 mt:h-5/6']"
      >
        <h5 class="font-bold">
          Thumbnail image
          <aha-icon
            class="ml-1 text-base-70"
            name="question"
            viewBox="0 0 24 24"
            width="15"
            height="15"
            v-tooltip="thumbnailTooltip"
          />
        </h5>
        <div class="h-full mt-2 form-group">
          <div v-if="!customThumbnailImage">
            <File
              :clickedAndMouseUp="trackUploadimage"
              @callback="handleImageUpload"
            />
          </div>
          <div
            class="flex items-center h-full slide-image-config horizontal layout"
            v-if="customThumbnailImage"
          >
            <div :class="[isInSettingTab ? 'image-box-setting' : 'image-box-modal']">
              <img :src="customThumbnailImage" alt>
            </div>
            <div>
              <div class="my-3">
                <a href="#">
                  <i class="pr-2 far fa-image text-primary-90" />
                  <span @click="openModalUploadImage">Change image</span>
                </a>
              </div>
              <div class="my-3">
                <a href="#">
                  <i class="pr-2 fas fa-trash-alt text-primary-90" />
                  <span
                    @click="deleteThumbnail()"
                  >Remove
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="w-full mt-5"
      >
        <div
          v-if="!isLoadingCategories"
          class="form-group"
        >
          <h5 class="mb-2 font-bold">
            Categories:
          </h5>
          <button
            v-for="item in allCategories"
            :key="`category-${item.categoryId}`"
            class="category-btn"
            :class="{ 'selected': item.selected == true }"
            @click="toogleClickedCategory(item)"
          >
            {{ item.shortName }}
          </button>
        </div>
        <div
          v-else
        >
          <h5 class="mb-2 font-bold">
            Categories:
          </h5>
          <Loading class="mx-auto" />
        </div>
      </div>
    </div>
    <UploadImage
      v-if="isUploadImageModalShowing"
      @callback="handleImageUpload"
      @hideModal="hideModalUploadImage"
    />
    <CropImage
      v-if="isCropImageModalShowing"
      :image-url="customThumbnailImageUrl"
      :isCropForMetaThumbnail="true"
      :aspect-ratio="16 / 9"
      @on-cancel="handleCancelCrop"
      @hideModal="isCropImageModalShowing = false"
      @handleCropImageFinished="handleCropImageFinished"
    />
    <div class="form-group">
      <aha-button
        class="my-2"
        v-if="isInSettingTab"
        @click="updatePresentation()"
        :disabled="updatingPresentation"
        :submitting="updatingPresentation"
      >
        Save
      </aha-button>
      <aha-button
        v-if="!isInSettingTab"
        @click="updateAndPublishPresentationAgain()"
        :disabled="updatingPresentation"
        :submitting="updatingPresentation"
        class="float-right mt-2 mb-2"
      >
        Done
      </aha-button>
    </div>
    <div class="overlay-disable-setting" v-if="isDisableEditPresentation"></div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import UploadImage from '@/components/presentations/UploadImage.vue'
import CropImage from '@/components/presentations/CropImage'
import Config from '@/config'
import Utils from '@/util'
import CommunityApi from '@/api/community'
import File from '@/components-v2/common/file/File.vue'
import gaCategories from '@/constant/gaCategories'
import EventBus from '@/eventBus'
import CategoryApi from '@/api/category'
import Loading from '@/components/Loading'

export default {
  components: {
    UploadImage,
    CropImage,
    File,
    Loading,
  },
  props: {
    presentation: {
      default: () => ({}),
      type: Object,
    },
    isInSettingTab: {
      type: Boolean,
      default: true,
    },
    hide: {
      type: Function,
      default: () => {},
    },
    currentCategories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      customThumbnailImageUrl: '_blank',
      isUploadImageModalShowing: false,
      isCropImageModalShowing: false,
      updatingPresentation: false,
      thumbnailTooltip: 'Presentation thumbnail and description will appear when you publish this presentation to the Template Library or share a copy with others.',
      isFocusDescription: false,
      allCategories: [],
      isLoadingCategories: false,
    }
  },
  computed: {
    ...mapState({
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
    }),
    description: {
      get() {
        return this.$store.state.presentation.description || ''
      },
      set(value) {
        const payload = {
          description: value,
        }
        this.$store.commit('updatePresentation', payload)
      },
    },
    name: {
      get() {
        return this.$store.state.presentation.name || ''
      },
      set(value) {
        const payload = {
          name: value,
        }
        this.$store.commit('updatePresentation', payload)
      },
    },
    customThumbnailImage: {
      get() {
        return this.$store.state.presentation.customThumbnailImage
      },
      set(value) {
        const payload = {
          customThumbnailImage: value,
        }
        this.$store.commit('updatePresentation', payload)
      },
    },
  },
  async created() {
    await this.categoriesProcessing()
  },
  mounted() {
    this.customThumbnailImageUrl = this.presentation.customThumbnailImage
  },
  methods: {
    ...mapActions(['patchPresentationAction', 'setPresentationsAction']),
    openModalUploadImage() {
      this.isUploadImageModalShowing = true
      this.trackUploadimage()
    },
    async handleImageUpload(imageUrl) {
      this.customThumbnailImageUrl = imageUrl
      this.isCropImageModalShowing = true
      this.isUploadImageModalShowing = false
    },
    hideModalUploadImage() {
      this.isUploadImageModalShowing = false
    },
    handleCancelCrop() {
      this.isCropImageModalShowing = false
      this.isUploadImageModalShowing = true
    },
    async handleCropImageFinished(data) {
      const { key, crop } = data
      const payload = {
        customThumbnailImage: key,
      }
      this._updatePresentationThumbnail(payload)
      this.patchPresentationAction({
        customThumbnailImage: crop,
      })
      this.isCropImageModalShowing = false
    },
    deleteThumbnail() {
      this._updatePresentationThumbnail({ customThumbnailImage: null })
      this.patchPresentationAction({
        customThumbnailImage: null,
      })
      this.customThumbnailImageUrl = null
      Utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, 'Presentation info > remove image', 'Thumbnail')
    },
    async _updatePresentationThumbnail(payload) {
      try {
        await this.$http.put(Config.api.updatePresentation + this.presentation.id, payload)
      } catch (error) {
        Utils.showToastError('Updating thumbnail failed. Please try again.')
        Utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, 'Presentation info > upload image > Failed', 'Thumbnail')
      }
    },

    async updatePresentation() {
      const selectedCategories = []
      this.allCategories.forEach((item) => {
        if (item.selected) {
          selectedCategories.push(item.categoryId)
        }
      })
      const payload = {
        name: this.name.trim(),
        description: this.description.trim(),
        categoryIds: selectedCategories,
      }
      this.updatingPresentation = true
      try {
        await this.$http.put(Config.api.updatePresentation + this.presentation.id, payload)
        if (payload.categoryIds.length > 0) {
          this.updateLatestCategoriesForPresentation(payload.categoryIds)
        }
        Utils.showToastSuccess('Presentation info updated.')
        Utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, 'Presentation info > Save', 'Updated Description Successfully')
      } catch (error) {
        Utils.showToastError('Updating description failed. Please try again.')
        Utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, 'Presentation info > Save > Failed', 'Updated Description Failed')
      } finally {
        this.updatingPresentation = false
      }
    },
    async updateAndPublishPresentationAgain() {
      if (this.name.trim().length === 0) {
        this.name = 'My new presentation'
      }
      const selectedCategories = []
      this.allCategories.forEach((item) => {
        if (item.selected) {
          selectedCategories.push(item.categoryId)
        }
      })
      const payload = {
        name: this.name.trim(),
        description: this.description.trim(),
        categoryIds: selectedCategories,
      }
      this.updatingPresentation = true
      try {
        await this.$http.put(Config.api.updatePresentation + this.presentation.id, payload)
        await CommunityApi.publishPresentation({
          presentationIds: [this.presentation.id],
          categoryIds: selectedCategories,
        })
        if (payload.categoryIds.length > 0) {
          this.updateLatestCategoriesForPresentation(payload.categoryIds)
        }
        Utils.showToastSuccess('Template info updated.')
      } catch (error) {
        Utils.showToastError('Something error, please try again in a few minutes.')
      } finally {
        const template = {
          id: this.presentation.id,
          name: this.name.trim(),
          description: this.description.trim(),
          customThumbnailImage: this.customThumbnailImageUrl,
          categoryIds: selectedCategories,
        }
        const newPresentations = this.$store.state.presentations.map((presentation) => {
          if (presentation.id === this.presentation.id) {
            presentation.isPublicSearch = true
            presentation.name = this.name.trim()
            presentation.description = this.description.trim()
            if (this.customThumbnailImageUrl !== '_blank') {
              presentation.customThumbnailImage = this.customThumbnailImageUrl
            }
          }
          return presentation
        })
        if (selectedCategories && selectedCategories.length === 0) {
          // Remove all selected if no option or user remove all option.
          this.$store.state.presentation.PresentationsCategories = []
        }
        this.setPresentationsAction(newPresentations) // Update metadata: Presentation list..
        EventBus.$emit('update-library-after-published', template) // Update metadata: TemplateLibrary
        EventBus.$emit('update-template-detail-after-published', template) // Update metadata: TemplateDetail
        EventBus.$emit('update-template-preview-after-published', template) // Update metadata: TemplatePreview
        EventBus.$emit('update-template-category')
        Utils.gaTrackEvent(null, 'Edit template info > Done', null, null, {
          customThumbnailImage: template.customThumbnailImage,
          name: template.name,
          description: template.description,
          id: template.id,
        })
        this.updatingPresentation = false
        const el = document.getElementById('zsiq_float')
        if (el) {
          el.style.display = 'block'
        }
        this.hide()
      }
    },
    trackUploadimage() {
      Utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, 'Presentation info > upload image', 'Thumbnail')
    },
    outFocusDes() {
      this.isFocusDescription = false
    },
    focusDes() {
      this.isFocusDescription = true
      Utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, 'Presentation info > Edit Description')
    },
    toogleClickedCategory(element) {
      element.selected = !element.selected
    },
    updateLatestCategoriesForPresentation(lists) {
      // eslint-disable-next-line sonarjs/no-identical-functions
      const categories = lists.map((item) => {
        return {
          categoryId: item,
          presentationId: this.presentation.id,
        }
      })
      const payload = {
        PresentationsCategories: categories,
      }
      this.$store.commit('updatePresentation', payload)
    },
    highlightCategories() {
      const categoriesList = this.currentCategories.map((item) => {
        return item.categoryId
      })
      this.allCategories.forEach((item) => {
        if (categoriesList.includes(item.categoryId)) {
          item.selected = true
        }
      })
    },
    async categoriesProcessing() {
      this.isLoadingCategories = true
      const res = await CategoryApi.getAllCategories()
      this.allCategories = res.data.map((item) => {
        return {
          categoryId: item.id,
          name: item.name,
          shortName: item.shortName,
          selected: false,
        }
      })
      this.highlightCategories()
      this.isLoadingCategories = false
    },
  },
}
</script>
<style lang="scss" scoped>
.slide-image-config {
  background-color: #f2f2f2;
  .image-box-setting {
    margin: 1rem 10px 1rem 1rem;
    img {
      max-width: 150px;
      max-height: 90px;
      border-radius: 0.5rem;
    }
  }
  .image-box-modal {
    img {
      margin: auto 10px auto 1rem;
      @media (max-width: 767.78px) {
        margin: 1rem 10px 1rem 10px;
      }
      max-width: 150px;
      max-height: 90px;
      border-radius: 0.5rem;
    }
  }
}

.text-area {
  position: relative;
  textarea {
    width: 100%;
    margin-top: 0.5rem;
    padding-left: 0.5rem;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 40px;
    min-height:3rem;
    border: 1px solid #ddd;
    border-radius: 0.25rem;
    resize: none;
    &:hover {
      border: 1px solid #348EF6;
      border-radius: 0.25rem;
    }
    &:focus {
      outline: none;
      -webkit-appearance: none;
    }
  }
  .text-area-expand {
    height: 7rem;
  }
  .count-text {
    position: absolute;
    font-size: 14px;
    right: 18px;
    top: 15px;
    color: #999;
  }
}
.overlay-disable-setting {
  @apply bg-base-0 opacity-50 absolute left-0 top-0 w-full h-full;
}
.info-row {
  display: flex;
  flex-flow: row wrap;
}
.info-col {
  display: flex;
  flex-flow: column;
}
h5 {
  color: rgba(10, 10, 10, 1);
}
.category-btn {
  border-radius: 20px;
  border: 1px solid #D3D7E1;
  padding: 6px 12px;
  margin: 4px 2px;
  height: 32px;
  color: #525F7F;
  cursor: pointer;
  pointer-events: auto;
  letter-spacing: 0px;
  transition: 0.15s linear;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  @media screen and (min-width: 640px) {
    &:hover {
      border: 1px solid #348EF6;
    }
  }
}
.category-btn.selected {
  border: 1px solid #348EF6;
  color: #348EF6;
}
</style>
